import {useTranslation} from 'react-i18next'
import {components} from 'react-select'

const CustomMenuList = (props: any) => {
  const {children, selectProps} = props
  const {t} = useTranslation()

  if (!selectProps.isMulti) {
    return <components.MenuList {...props}>{children}</components.MenuList>
  }

  return (
    <div>
      <components.MenuList {...props}>{children}</components.MenuList>

      <div
        style={{
          padding: '8px',
          borderTop: '1px solid #eee',
          display: 'flex',
          gap: '8px',
          background: 'white',
        }}
      >
        <button
          className='btn btn-primary btn-sm w-50 fw-bold'
          onClick={selectProps.confirmHandler}
        >
          <span className='fa fa-check mx-2'></span>
          {t('VALIDATION.SELECT_', {name: ''})}
        </button>

        <button className='btn btn-danger btn-sm w-50 fw-bold' onClick={selectProps.cancelHandler}>
          <span className='fa fa-times mx-2'></span>
          Cancel
        </button>
      </div>
    </div>
  )
}

export default CustomMenuList
